// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__SzVKk"};